import { render, staticRenderFns } from "./ComandoVelocidad.vue?vue&type=template&id=5fcb2a5a&"
import script from "./ComandoVelocidad.vue?vue&type=script&lang=ts&"
export * from "./ComandoVelocidad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5fcb2a5a', component.options)
    } else {
      api.reload('5fcb2a5a', component.options)
    }
    module.hot.accept("./ComandoVelocidad.vue?vue&type=template&id=5fcb2a5a&", function () {
      api.rerender('5fcb2a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ComandoVelocidad/ComandoVelocidad.vue"
export default component.exports